function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t); "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) { return Object.getOwnPropertyDescriptor(t, e).enumerable; })), o.forEach(function (r) { _defineProperty(e, r, t[r]); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import uriTemplates from 'uri-templates';
import httpOptions from './httpOptions';
import fetcher from './fetcher';
// TypeScript custom type guard
function isHalJson(json) {
  return !!(json && typeof json !== 'string' && json._links);
}
function getLink(json, rel, params) {
  var links;
  if (isHalJson(json)) {
    links = json._links;
  } else {
    throw new Error("Response does not have a _links property");
  }
  var url = links && links[rel];
  if (!url) {
    throw new Error("No rel \"".concat(rel, "\" found in _links"));
  } else if (url.templated) {
    return uriTemplates(url.href).fill(params);
  } else {
    return url.href;
  }
}
function baseFetch(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var rels = arguments.length > 2 ? arguments[2] : undefined;
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var singleOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  return fetcher(url, _objectSpread({}, options, singleOptions)).then(function (res) {
    var nextRel = rels[0];
    if (res && nextRel) {
      var _ref = typeof nextRel === 'string' ? {
          rel: nextRel
        } : nextRel,
        rel = _ref.rel,
        _ref$options = _ref.options,
        nextOptions = _ref$options === void 0 ? {} : _ref$options,
        _ref$params = _ref.params,
        nextParams = _ref$params === void 0 ? {} : _ref$params;
      return baseFetch(getLink(res.data, rel, _objectSpread({}, params, nextParams)), options, rels.slice(1), params, nextOptions);
    } else {
      return res;
    }
  });
}

// TypeScript custom type guard
function isHal(obj) {
  return obj.hasOwnProperty('rels');
}
export default function halFetch(url, hal) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var opts = httpOptions.getOptions(options);
  var rels = [];
  var params = {};
  if (isHal(hal)) {
    params = hal.params || {};
    if (typeof hal.rels === 'string') {
      rels = [hal.rels];
    } else if (Array.isArray(hal.rels)) {
      rels = hal.rels;
    } else {
      throw new Error("Supplied hal.rels is not of type string or array, supplied: ".concat(typeof hal.rels));
    }
  } else {
    // no hal object
    opts = Object.keys(hal).length ? hal : opts;
    console.warn("Why are you using halFetch if you don't want rels fetched?");
  }
  return baseFetch(url, opts, rels, params);
}